module.exports = __webpack_public_path__ + "img/asset_delete.c576ab02.svg";